// Leave the demo (TOM-868): the banner's Leave the demo, and Sign out for a
// Try it guest. It ends the guest's lease with `DELETE /v1/demo/lease`, so the
// demo boat is free for the next visitor at once, and then signs out.

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { api } from '../api';
import { useAuth } from '../auth';
import { markDemoGuest } from './demo';

export function useLeaveDemo(): () => Promise<void> {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return useCallback(async () => {
    // Cleared first, so a 401 from a request still in flight, or from the
    // DELETE itself, is not read as the lease ending.
    markDemoGuest(false);
    // Off the app page first: signed out on it, RequireAuth would send the
    // visitor to sign-in instead.
    navigate('/');
    try {
      await api('/v1/demo/lease', { method: 'DELETE' });
    } catch {
      // The lease may have ended already. The visitor is signed out either way.
    }
    await logout();
  }, [logout, navigate]);
}
